import type {
  EnumPersonaGiuridicaDTOTipoPg,
  TipoUtenteCardinalitaDTO,
  TipoUtenteDTO,
} from '@framework/api-client';

/**
 * Mappa il tipo di Persona Giuridica al `codice` del tipo utente destinatario
 * delle domande (valori stabili lato backend, cfr. RecipientTypeText).
 */
export const recipientCodeByLegalEntityType: Record<
  EnumPersonaGiuridicaDTOTipoPg,
  string
> = {
  PUBBLICA: 'ENTE_PUBBLICO',
  PRIVATA: 'PERSONA_GIURIDICA',
};

/** Codici dei tipi utente destinatario riconducibili a una Persona Giuridica. */
export const legalEntityRecipientCodes: Set<string> = new Set(
  Object.values(recipientCodeByLegalEntityType),
);

/**
 * True se tutti i destinatari sono riconducibili a una Persona Giuridica
 * (domanda esclusiva per Persone Giuridiche). Nessuna politica sui dati
 * mancanti (destinatari vuoti o tipi utente non caricati): la decidono i
 * chiamanti.
 */
export function hasOnlyLegalEntityRecipients(
  recipients: (TipoUtenteCardinalitaDTO | undefined)[],
  userKinds: TipoUtenteDTO[],
): boolean {
  return recipients.every(recipient => {
    const kind = userKinds.find(
      userKind => userKind.id === recipient?.idTipoUtente,
    );
    return !!kind?.codice && legalEntityRecipientCodes.has(kind.codice);
  });
}
